// Total columns for weekly depletion
export const weeklyDepTotalCols = [
  {
    field: "unusedQuota",
    headerName: "Unused Quota- Previous Period",
    disableColumnMenu: false,
    filterable: true,
    flex: 1,
    align: "center",
    headerAlign: "center",
    hideSortIcons: "false",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "initialQuota",
    headerName: "Initial Quota",
    align: "center",
    headerAlign: "center",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
    renderHeader: (params) => {
      return (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            lineHeight: "normal",
            fontWeight: 600,
          }}
        >
          {params.colDef.headerName}
        </span>
      );
    },
  },
  // {
  //   field: "safetyMargin",
  //   headerName: "Safety Margin",
  //   width: 150,
  //   align: "center",
  //   headerAlign: "center",
  //   valueFormatter: (params) => {
  //     const formattedValue = params.value?.toLocaleString("en-US");
  //     return formattedValue;
  //   },
  // },
  {
    field: "adjustment",
    headerName: "Adjustment",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "quota",
    headerName: "Quota",
    align: "center",
    headerAlign: "center",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly1",
    headerName: "Week1",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly2",
    headerName: "Week2",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly3",
    headerName: "Week3",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly4",
    headerName: "Week4",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly5",
    headerName: "Week5",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "sit",
    headerName: "SIT",
    disableColumnMenu: false,
    filterable: true,
    align: "center",
    headerAlign: "center",
    hideSortIcons: "false",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
];

// Total columns for biweekly depletion
export const biWeeklyDepTotalCols = [
  {
    field: "unusedQuota",
    headerName: "Unused Quota- Previous Period",
    disableColumnMenu: false,
    filterable: true,
    flex: 1,
    align: "center",
    headerAlign: "center",
    hideSortIcons: "false",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "initialQuota",
    headerName: "Initial Quota",
    disableColumnMenu: false,
    filterable: true,
    align: "center",
    headerAlign: "center",
    hideSortIcons: "false",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
    renderHeader: (params) => {
      return (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            lineHeight: "normal",
            fontWeight: 600,
          }}
        >
          {params.colDef.headerName}
        </span>
      );
    },
  },
  // {
  //   field: "safetyMargin",
  //   headerName: "Safety Margin",
  //   flex: 1,
  //   align: "center",
  //   headerAlign: "center",
  //   valueFormatter: (params) => {
  //     const formattedValue = params.value?.toLocaleString("en-US");
  //     return formattedValue;
  //   },
  // },
  {
    field: "adjustment",
    headerName: "Adjustment",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "quota",
    headerName: "Quota",
    align: "center",
    headerAlign: "center",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly1",
    headerName: "First Half",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "weekly2",
    headerName: "Second Half",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "sit",
    headerName: "SIT",
    disableColumnMenu: false,
    filterable: true,
    align: "center",
    headerAlign: "center",
    hideSortIcons: "false",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
];

// Total columns for no depletion
export const noDepTotalCols = [
  {
    field: "unusedQuota",
    headerName: "Unused Quota- Previous Period",
    disableColumnMenu: false,
    filterable: true,
    hideSortIcons: "false",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "initialQuota",
    headerName: "Initial Quota",
    disableColumnMenu: false,
    filterable: true,
    hideSortIcons: "false",
    align: "center",
    flex: 1,
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
    renderHeader: (params) => {
      return (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            lineHeight: "normal",
            fontWeight: 600,
          }}
        >
          {params.colDef.headerName}
        </span>
      );
    },
  },
  // {
  //   field: "safetyMargin",
  //   headerName: "Safety Margin",
  //   flex: 1,
  //   align: "center",
  //   headerAlign: "center",
  //   valueFormatter: (params) => {
  //     const formattedValue = params.value?.toLocaleString("en-US");
  //     return formattedValue;
  //   },
  // },
  {
    field: "adjustment",
    headerName: "Adjustment",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "quota",
    headerName: "Quota",
    align: "center",
    flex: 1,
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "sit",
    headerName: "SIT",
    disableColumnMenu: false,
    filterable: true,
    hideSortIcons: "false",
    align: "center",
    headerAlign: "center",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
];


export const summaryTotalView = [
  {
    field: "safetyMargin",
    headerName: "Safety Margin",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "adjustment",
    headerName: "Adjustment",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "quota",
    headerName: "Quota",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString("en-US");
      return formattedValue;
    },
  },
];

